import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../providers/auth";

export default ({ children }: { children: ReactNode }) => {
  const { loading, authenticated, oid, session } = useAuth();
  console.log({ oid, session, loading, authenticated });
  if (loading) {
    return (
      <div className="flex h-screen">
        <div className="m-auto">
          <span className="loading loading-dots loading-lg"></span>
        </div>
      </div>
    );
  }
  return authenticated ? children : <Navigate to="/sign-in" replace />;
};
